module.exports = __webpack_public_path__ + "img/vignettes-asso_0007_notre-dame-de-lassomption.90b19746.jpg";